<template>
    <div class="main-slider" ref="slider-wrapper">
        <div class="main-slider__overlay"></div>
        <div class="swiper-container main-slider__container" ref="slider">
            <div class="swiper-wrapper">
                <div class="swiper-slide main-slider__slide"
                     v-for="(item, index) in slides"
                     :key="index"
                >
                    <div :class="['main-slider__inner']"
                         :style="`background-image: url(${item.image})`"
                         ref="slide-image">
                    </div>
                    <div class="main-slider__info">
                        <p class="main-slider__text" v-html="item.text"/>
                        <z-button tag="a" size="l" kind="text" :href="`/${$root.lang}/products`">
                            {{ item.button }}
                            <z-icon name="modal-arrow" dir="right" width="40" height="40"/>
                        </z-button>
                    </div>
                </div>
            </div>
            <div class="main-slider__controls">
                <div class="main-slider__controls-container" ref="controls-container">
                    <div class="main-slider__controls-wrapper">
                        <div class="main-slider__fraction" ref="fraction"></div>
                        <div ref="pagination"
                             :class="[
                                'main-slider__pagination main-slider-pagination',
                                { 'main-slider-pagination--freez' : !isAutoplay }
                            ]">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mixinDevice} from '@/utils/mixin'
import Swiper from 'swiper/dist/js/swiper.js'
import 'swiper/dist/css/swiper.min.css'
import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui.js'
import {mapActions} from 'vuex'

export default {
    name: 'main-slider',
    mixins: [mixinDevice],
    props: {
        localizedText: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            slides: [],
            isAutoplay: true
        }
    },
    methods: {
        ...mapActions(['MenuInvert']),
        initSlider () {
            const _this = this

            let options = {
                speed: 300,
                loop: true,
                simulateTouch: false,
                observer: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                observeParents: true,
                slidesPerView: 1,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                autoplay: {
                    delay: 5000
                },
                pagination: {
                    el: this.$refs.pagination,
                    clickable: true,
                    bulletClass: 'main-slider-pagination__bullet',
                    bulletActiveClass: 'main-slider-pagination__bullet--active',
                    type: 'custom',
                    renderCustom: function (swiper, current, total) {
                        let bullets = ''
                        for (let i = 0; i < total; i++) {
                            let className = i === current - 1
                                ? 'main-slider-pagination__bullet main-slider-pagination__bullet--active'
                                : 'main-slider-pagination__bullet'
                            bullets += `<span class="${className}"></span>`
                        }

                        let currentSlide = current < 10 ? `0${current}` : current
                        let totalSlides = total < 10 ? `0${total}` : total
                        _this.$refs.fraction.innerHTML = `<span class="main-slider-pagination__fraction">${currentSlide}/${totalSlides}</span>`

                        return bullets
                    }
                },
                on: {
                    autoplayStop () {
                        _this.isAutoplay = false
                    },
                    slideChange () {
                        _this.MenuInvert(_this.slides[this.realIndex].invertMenu)
                    },
                    slideChangeTransitionEnd () {
                        _this.animateCurrentSlide()
                    }
                }
            }

            this.slider = new Swiper(this.$refs.slider, options)
            this.slider.update()
        },
        animateCurrentSlide () {
            const slide = document.querySelector('.swiper-slide-active')
            const button = slide.querySelector('.main-slider__link-wrapper')
            const image = slide.querySelector('.main-slider__inner')

            if (button) Velocity(button, 'stop')
            if (image) Velocity(image, 'stop')

            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
            const duration = isSafari ? 2500 : 2000

            if (image) Velocity(image, {scale: 1}, {duration: duration, delay: 100, easing: 'easeOutQuad'})
            if (button) Velocity(button, 'transition.slideUpIn', {duration: 900, delay: 700})

            this.resetAnimationState()
        },
        resetAnimationState () {
            let slides = Array.from(document.querySelectorAll('.swiper-slide:not(.swiper-slide-active)'))
            slides.forEach((slide, i) => {
                const button = slide.querySelector('.main-slider__link-wrapper')
                const image = slide.querySelector('.main-slider__inner')
                if (image) Velocity(image, {scale: '1.5', translateZ: 0}, {duration: 3000, delay: 3})
                if (button) Velocity(button, {translateY: '100%', opacity: 0}, {duration: 0, delay: 0})
            })
        },
        init () {
            if (this.slides.length > 0 && this.slides[0].invertMenu) {
                this.MenuInvert(true)
            }

            this.initSlider()

            const controls = this.$refs['controls-container']

            if (controls) {
                Velocity(controls, {
                    opacity: 1,
                    scale: 1
                }, {
                    duration: 1000,
                    delay: 300,
                    easing: 'easeOutQuad'
                })
            }
        }
    },
    watch: {
        localizedText: {
            immediate: true,
            handler (newText) {
                if (newText && newText.slider) {
                    this.slides = [
                        {
                            image: '/images/main-page/slider/slide-1.jpg',
                            text: newText.slider[0].text,
                            button: newText.prodButton
                        },
                        {
                            image: '/images/main-page/slider/slide-2.jpg',
                            text: newText.slider[1].text,
                            button: newText.prodButton
                        },
                        {
                            image: '/images/main-page/slider/slide-3.jpg',
                            text: newText.slider[2].text,
                            button: newText.prodButton
                        },
                        {
                            image: '/images/main-page/slider/slide-4.jpg',
                            text: newText.slider[3].text,
                            button: newText.prodButton
                        },
                        {
                            image: '/images/main-page/slider/slide-5.jpg',
                            text: newText.slider[4].text,
                            button: newText.prodButton
                        }
                    ]
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.init()
                        }, 100)
                    })
                }
            }
        }
    }
}
</script>

<style lang="scss">
.main-slider {
    position: relative;
    max-width: 100%;

    &__overlay {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        pointer-events: none;
        background: rgba(191, 197, 197, 0.50);
        mix-blend-mode: multiply;
    }

    &__container {
        height: 100%;
    }

    &__slide {
        position: relative;
        overflow: hidden;

        > .container {
            height: 100%;
        }
    }

    &__link-wrapper {
        margin-top: $token-spacers-xxl;
        opacity: 0;
        display: block;
        transform: translateY(100%);
        will-change: opacity, transform;
    }

    &__link {
        padding-right: $token-spacers-s !important;
        padding-left: $token-spacers-s !important;

        @include breakpoint(mobile) {
            width: auto !important;
        }
    }

    &__inner {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 1;
        will-change: transform;

        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: #BFC5C5;
            mix-blend-mode: multiply;
        }
    }

    &__info {
        width: max-content;
        max-width: 100%;
        position: relative;
        margin: 0 auto;
        z-index: 3;
        padding-top: 470px;
        padding-bottom: 270px;
        padding-left: 200px;
        flex-direction: column;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        will-change: transform, opacity;

        @include breakpoint(laptop) {
            padding-top: 350px;
            padding-bottom: 230px;
        }

        @include breakpoint(tablet) {
            padding-top: 280px;
            padding-left: $token-spacers-m;
            padding-right: $token-spacers-m;
            margin: 0;
        }

        @include breakpoint(v-tablet) {
            padding-top: 250px;
            padding-bottom: 300px;
        }

        @include breakpoint(mobile) {
            padding-top: 150px;
            padding-left: $token-spacers-xxs;
        }

        &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 340px;
            width: 100%;
            height: 416px;
            border-radius: 300px;
            background: rgba(50, 51, 53, 0.50);
            filter: blur(200px);

            @include breakpoint(laptop) {
                top: 270px;
                height: 350px;
            }

            @include breakpoint(tablet) {
                top: 194px;
                height: 300px;
            }

            @include breakpoint(mobile) {
                top: 85px;
                height: 250px;
            }
        }
    }

    &__controls {
        position: absolute;
        z-index: 4;
        bottom: 100px;
        left: $token-spacers-xl;
        display: flex;
        align-items: center;
        pointer-events: none;
        padding-left: $token-spacers-xxs;

        @include breakpoint(tablet) {
            left: $token-spacers-s;
        }

        @include breakpoint(v-tablet) {
            bottom: 210px;
        }

        @include breakpoint(mobile) {
            bottom: 195px;
            left: 0;
        }

        &:before {
            content: '';
            position: absolute;
            left: 0;
            top: -35px;
            width: 100%;
            height: 112px;
            border-radius: 100px;
            background: linear-gradient(144deg, rgba(15, 18, 19, 0.60) 67.78%, rgba(96, 115, 121, 0.60) 176.05%);
            filter: blur(150px);
        }

        &-wrapper {
            display: flex;
            align-items: center;
            gap: 40px;
        }
    }

    &__pagination {
        pointer-events: all;
    }

    &__fraction {
        z-index: 2;
    }

    &__text {
        position: relative;
        color: $token-colors-white;
        margin-bottom: $token-spacers-s;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        max-width: 560px;

        @include breakpoint(v-tablet) {
            font-size: 20px;
        }

        @include breakpoint(mobile) {
            max-width: 100%;
            font-size: 16px;
        }
    }

    .z-button {
        text-transform: none;
        color: $token-colors-white;
        font-size: 20px;
        z-index: 4;

        &:hover {
            color: $token-colors-white;

            .z-icon {
                margin-left: 6px;

                path {
                    fill: $token-colors-white;
                }
            }
        }

        .z-icon {
            transition: all 0.2s ease-in-out;

            path {
                fill: $token-colors-white;
            }
        }

        @include breakpoint(mobile) {
            font-size: 16px;
        }
    }
}

.main-slider-pagination {
    $parent: &;
    display: flex;
    align-items: center;
    gap: $token-spacers-xs;

    &--freez {
        .main-slider-pagination__bullet {
            &--active {
                &:after {
                    animation: none;
                    transform: translate3d(0, 0, 0);
                }
            }
        }
    }

    &__fraction {
        font-size: 20px;
        font-weight: 500;
        color: $token-colors-white;
    }

    &__bullet {
        position: relative;
        outline: none;
        cursor: pointer;
        padding-bottom: 20px;
        display: block;
        width: 20px;
        overflow: hidden;

        @include breakpoint(tablet) {
            color: #000;
        }

        &:before,
        &:after {
            content: '';
            height: 20px;
            width: 20px;
            position: absolute;
            bottom: 0;
            left: 0;
        }

        &:before {
            background: $token-colors-white;
        }

        &:after {
            background: $token-colors-primary;
            width: 100%;
            transform: translate3d(-100%, 0, 0);
        }

        &--active {
            &:after {
                animation: 5s timer;
                animation-fill-mode: forwards;
            }
        }
    }
}

@keyframes timer {
    0% {
        transform: translate3d(-100%, 0, 0);
    }

    100% {
        transform: translate3d(0, 0, 0);
    }
}

</style>
